__turbopack_context__.v({
  "error": "Input-module-scss-module__R6-G4W__error",
  "fade-in": "Input-module-scss-module__R6-G4W__fade-in",
  "input": "Input-module-scss-module__R6-G4W__input",
  "licensePlateBadge": "Input-module-scss-module__R6-G4W__licensePlateBadge",
  "no-transform": "Input-module-scss-module__R6-G4W__no-transform",
  "rotate": "Input-module-scss-module__R6-G4W__rotate",
  "state": "Input-module-scss-module__R6-G4W__state",
  "success": "Input-module-scss-module__R6-G4W__success",
  "suffix": "Input-module-scss-module__R6-G4W__suffix",
  "unit": "Input-module-scss-module__R6-G4W__unit",
  "unitStart": "Input-module-scss-module__R6-G4W__unitStart",
  "wrapper": "Input-module-scss-module__R6-G4W__wrapper",
});
